import { InjectionToken } from '@angular/core';

/**
 * How the switcher dialog closes itself. Provided by
 * `WorkspaceSwitcherDialogService` into the portal's injector; kept in its
 * own file so the component and the service do not import each other.
 */
export const WORKSPACE_SWITCHER_CLOSE = new InjectionToken<() => void>(
  'WORKSPACE_SWITCHER_CLOSE',
);
